(function(){
'use strict';
var LS='fdClearanceSizes';
var state={};
var catFilter='all';
var discMin=0;
var discMax=0;
try{state=JSON.parse(localStorage.getItem(LS)||'{}')||{};}catch(e){state={};}
function save(){try{localStorage.setItem(LS,JSON.stringify(state));}catch(e){}}
function norm(s){return String(s||'').toUpperCase().replace(/[^A-Z0-9+]/g,'');}
function qs(s,r){return (r||document).querySelector(s);}
function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
function vLabel(t){return String(t).replace('Default Title','One size').replace(' | Age 3-6','').replace(' | Age 6-10','');}
function escA(s){return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');}

/* Per-SKU sale list (Aug 2026, socks excluded) */
var SALE_VIDS=new Set(); /* post-sale: on-sale = live compare-at > price only */
function chipOnSale(ch){
  return ch.getAttribute('data-sale')==='1'||SALE_VIDS.has(ch.getAttribute('data-vid'));
}
function saleChips(card){
  return qsa('.clx-size[data-vid]',card).filter(function(c){return chipOnSale(c)&&!c.disabled;});
}
function initSaleSkus(){
  qsa('.clx-card').forEach(function(card){
    var chips=qsa('.clx-size[data-vid]',card);
    var onSale=0;
    chips.forEach(function(ch){
      if(chipOnSale(ch)){onSale++;}else{ch.classList.add('clx-size--offsale');}
    });
    if(chips.length){
      if(!onSale)card.classList.add('is-offsale');
    }else{
      var single=card.getAttribute('data-single-vid');
      var pct=parseInt(card.getAttribute('data-pct')||'0',10);
      if(single&&!SALE_VIDS.has(single)&&pct<=0)card.classList.add('is-offsale');
    }
  });
}

/* size selection: gate buttons + dropdown panel chips share .clx-opt and state */
function initGate(){
  qsa('.clx-opt').forEach(function(btn){
    btn.addEventListener('click',function(){
      var dim=btn.getAttribute('data-dim'), val=btn.getAttribute('data-val');
      if(state[dim]===val){delete state[dim];}else{state[dim]=val;}
      save(); paintGate(); applyFilter();
    });
  });
  var gate=qs('#clx-gate');
  var cta=qs('#clx-show-deals');
  if(cta&&gate) cta.addEventListener('click',function(){
    gate.classList.add('is-collapsed'); paintGate(); applyFilter();
    var grid=qs('#clx-grid-anchor'); if(grid) grid.scrollIntoView({behavior:'smooth'});
  });
  var upd=qs('#clx-update-sizes');
  if(upd&&gate) upd.addEventListener('click',function(){ gate.classList.remove('is-collapsed'); });
  if(gate&&(state.sleeve||state.glove||state.uv)) gate.classList.add('is-collapsed');
  paintGate();
}
function sizeSummary(){
  var parts=[];
  if(state.sleeve)parts.push('Sleeves '+state.sleeve);
  if(state.glove&&state.glove!=='skip')parts.push('Gloves '+state.glove);
  if(state.uv&&state.uv!=='skip')parts.push('UV '+state.uv);
  if(state.kids&&state.kids!=='skip')parts.push('Kids '+(state.kids.split(' | ')[1]||state.kids));
  return parts.join(' · ');
}
function paintGate(){
  qsa('.clx-opt').forEach(function(b){
    b.classList.toggle('is-on', state[b.getAttribute('data-dim')]===b.getAttribute('data-val'));
  });
  var pill=qs('#clx-pill-text');
  var sum=sizeSummary();
  if(pill){pill.textContent=sum?('Your sizes — '+sum):'No sizes picked';}
  var sbtn=qs('#clx-sizebtn');
  if(sbtn){
    sbtn.classList.toggle('is-set',!!sum);
    sbtn.innerHTML=(sum?'Change Your Size':'Select Size')+' <span class="clx-sizebtn__caret">▾</span>';
  }
  var ssum=qs('#clx-size-summary');
  if(ssum){ssum.textContent=sum;}
}
function initSizePanel(){
  var btn=qs('#clx-sizebtn'), panel=qs('#clx-sizepanel'), done=qs('#clx-sizepanel-done');
  if(!btn||!panel)return;
  btn.addEventListener('click',function(e){
    e.stopPropagation();
    panel.hidden=!panel.hidden;
  });
  if(done)done.addEventListener('click',function(){panel.hidden=true;});
  document.addEventListener('click',function(e){
    if(panel.hidden)return;
    if(e.target.closest&&(e.target.closest('#clx-sizepanel')||e.target.closest('#clx-sizebtn')))return;
    panel.hidden=true;
  });
}

/* card variant selection among SALE chips */
function cardVid(card){
  var chips=saleChips(card);
  if(!chips.length){
    var single=card.getAttribute('data-single-vid');
    if(single&&(SALE_VIDS.has(single)||parseInt(card.getAttribute('data-pct')||'0',10)>0))return single;
    return single||null;
  }
  var sel=card.getAttribute('data-selvid');
  if(sel){var hit=chips.filter(function(c){return c.getAttribute('data-vid')===sel;})[0]; if(hit)return sel;}
  var dim=card.getAttribute('data-dim')||'none'; var gsel=state[dim];
  if(gsel&&gsel!=='skip'){
    var m=chips.filter(function(c){return norm(c.getAttribute('data-size'))===norm(gsel);})[0];
    if(m)return m.getAttribute('data-vid');
  }
  if(chips.length===1)return chips[0].getAttribute('data-vid');
  return null;
}
function paintCards(){
  qsa('.clx-card').forEach(function(card){
    var vid=cardVid(card);
    qsa('.clx-size[data-vid]',card).forEach(function(ch){
      ch.classList.toggle('is-match', ch.getAttribute('data-vid')===vid);
    });
    var atc=qs('.clx-card__atc',card);
    if(atc&&!atc.classList.contains('is-busy')){
      atc.disabled=!vid;
      atc.textContent=vid?'Add to Cart':'Pick a size';
    }
  });
}

/* filtering */
function applyFilter(){
  qsa('.clx-card').forEach(function(card){
    if(card.classList.contains('is-offsale'))return;
    var show=true;
    var cat=card.getAttribute('data-cat');
    if(cat&&catFilter!=='all'&&cat!==catFilter) show=false;
    if(show&&discMin>0){
      var pct=parseInt(card.getAttribute('data-pct')||'0',10);
      if(pct<discMin||(discMax>0&&pct>=discMax)) show=false;
    }
    if(show){
      var dim=card.getAttribute('data-dim')||'none';
      var sel=state[dim];
      if(dim!=='none'&&sel&&sel!=='skip'){
        var chips=saleChips(card);
        if(chips.length){
          show=chips.some(function(c){return norm(c.getAttribute('data-size'))===norm(sel);});
        }else{
          /* no interactive chips (incl. single-size final-sale cards): match the raw size list */
          var sizes=(card.getAttribute('data-sizes')||'').split('|').map(norm).filter(Boolean);
          if(sizes.indexOf('DEFAULTTITLE')>-1||sizes.indexOf('ONESIZE')>-1){
            /* one-size products fit everyone: never hide on a size filter */
          }else if(sizes.length){
            show=sizes.indexOf(norm(sel))>-1;
          }
        }
      }
    }
    card.classList.toggle('is-hidden',!show);
  });
  qsa('.clx-bcard--grid').forEach(function(b){
    b.classList.toggle('is-hidden', b.getAttribute('data-cat')!==catFilter);
  });
  var main=qs('.clx-grid--main');
  if(main){
    var vis=qsa('.clx-card',main).filter(function(c){return !c.classList.contains('is-hidden')&&!c.classList.contains('is-offsale');}).length;
    var empty=qs('#clx-grid-empty'); if(empty) empty.style.display=vis?'none':'block';
  }
  paintCards();
  paintBundles();
}

function initCatChips(){
  qsa('.clx-chip').forEach(function(chip){
    chip.addEventListener('click',function(){
      catFilter=chip.getAttribute('data-cat')||'all';
      qsa('.clx-chip').forEach(function(x){x.classList.toggle('is-on',x===chip);});
      applyFilter();
      var anchor=qs('#clx-grid-anchor'); if(anchor){var top=anchor.getBoundingClientRect().top;if(top<-40||top>200){anchor.scrollIntoView({behavior:'smooth'});}}
    });
  });
  qsa('.clx-dchip').forEach(function(chip){
    chip.addEventListener('click',function(){
      discMin=parseInt(chip.getAttribute('data-min')||'0',10);
      discMax=parseInt(chip.getAttribute('data-max')||'0',10);
      qsa('.clx-dchip').forEach(function(x){x.classList.toggle('is-on',x===chip);});
      applyFilter();
    });
  });
}

/* cart */
function addItems(items,btn){
  var old=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.classList.add('is-busy');btn.textContent='Adding…';}
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
    .then(function(){refreshBar();openCart();if(btn){btn.textContent='Added ✓';setTimeout(function(){btn.textContent=old;btn.disabled=false;btn.classList.remove('is-busy');paintCards();},1800);}return true;})
    .catch(function(){if(btn){btn.textContent='Try again';btn.disabled=false;btn.classList.remove('is-busy');}return false;});
}
function openCart(){
  /* theme's CartDrawer rebuilds its contents + opens on this event; a bare
     drawer-open click shows a stale (empty) cart after our fetch-based add */
  if(document.getElementById('CartDrawer')){
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  } else {
    var t=qs('.js-drawer-open-cart');
    if(t){t.click();}
  }
}

/* quick-look modal (with sizes + Add to Cart) */
var modal=null;
function ensureModal(){
  if(modal)return modal;
  modal=document.createElement('div');
  modal.className='clx-modal';
  modal.innerHTML='<div class="clx-modal__bg"></div><div class="clx-modal__panel"><button type="button" class="clx-modal__close" aria-label="Close">×</button><div class="clx-modal__content"></div></div>';
  document.body.appendChild(modal);
  qs('.clx-modal__bg',modal).addEventListener('click',closeModal);
  qs('.clx-modal__close',modal).addEventListener('click',closeModal);
  return modal;
}
function closeModal(){if(modal)modal.classList.remove('is-open');}
function modalVid(d){
  var chips=qsa('.clx-size[data-mvid]',d);
  if(!chips.length)return d.getAttribute('data-onevid')||null;
  var sel=d.getAttribute('data-msel');
  if(sel&&chips.some(function(c){return c.getAttribute('data-mvid')===sel;}))return sel;
  var wants=[state.sleeve,state.glove,state.uv].filter(function(x){return x&&x!=='skip';});
  for(var i=0;i<wants.length;i++){
    var m=chips.filter(function(c){return norm(c.getAttribute('data-size'))===norm(wants[i]);})[0];
    if(m)return m.getAttribute('data-mvid');
  }
  if(chips.length===1)return chips[0].getAttribute('data-mvid');
  return null;
}
function paintModalItem(d){
  var vid=modalVid(d);
  qsa('.clx-size[data-mvid]',d).forEach(function(c){
    c.classList.toggle('is-match',c.getAttribute('data-mvid')===vid);
  });
  var atc=qs('.clx-qp__atc',d);
  if(atc&&!atc.classList.contains('is-busy')){
    atc.disabled=!vid;
    atc.textContent=vid?'Add to Cart':'Pick a size';
  }
}
function openQuick(handles){
  var m=ensureModal();
  var c=qs('.clx-modal__content',m);
  c.innerHTML='<p style="padding:30px;text-align:center">Loading…</p>';
  m.classList.add('is-open');
  Promise.all(handles.map(function(h){
    h=h.trim();
    return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).then(function(j){return {h:h,p:j};}).catch(function(){return {h:h,p:null};});
  })).then(function(rs){
    c.innerHTML='';
    var loaded=rs.filter(function(r){return r.p;}), failed=rs.length-loaded.length;
    loaded.forEach(function(r){
      var p=r.p;
      var d=document.createElement('div'); d.className='clx-qp';
      var imgs=(p.images||[]).slice(0,5);
      var desc=(p.description||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim();
      if(desc.length>280)desc=desc.slice(0,280)+'…';
      var priceHtml='$'+(p.price/100).toFixed(2);
      if(p.compare_at_price&&p.compare_at_price>p.price){priceHtml+=' <span class="clx-card__was">$'+(p.compare_at_price/100).toFixed(2)+'</span>';}
      var vs=(p.variants||[]).filter(function(v){return v.available!==false&&(SALE_VIDS.has(String(v.id))||(v.compare_at_price&&v.compare_at_price>v.price));});
      if(!vs.length)vs=(p.variants||[]).filter(function(v){return v.available!==false;});
      var sizesHtml='';
      if(vs.length>1){
        sizesHtml='<div class="clx-sizes clx-qp__sizes">'+vs.map(function(v){
          return '<button type="button" class="clx-size" data-mvid="'+v.id+'" data-size="'+escA(v.title)+'">'+escA(vLabel(v.title))+'</button>';
        }).join('')+'</div>';
      }else if(vs.length===1){
        d.setAttribute('data-onevid',String(vs[0].id));
      }
      d.innerHTML=(imgs[0]?'<img class="clx-qp__main" src="'+imgs[0]+'" alt="">':'')
        +(imgs.length>1?'<div class="clx-qp__thumbs">'+imgs.map(function(u,i){return '<img class="clx-qp__thumb'+(i===0?' is-on':'')+'" src="'+u+'" alt="">';}).join('')+'</div>':'')
        +'<div class="clx-qp__title">'+p.title+'</div>'
        +'<div class="clx-qp__price">'+priceHtml+'</div>'
        +sizesHtml
        +'<button type="button" class="clx-card__atc clx-qp__atc">Add to Cart</button>'
        +'<div class="clx-qp__desc">'+desc+'</div>'
        +'<a class="clx-qp__link" href="/products/'+r.h+'">View full product page →</a>';
      d.addEventListener('click',function(e){
        var t=e.target;
        if(t.classList&&t.classList.contains('clx-qp__thumb')){
          qs('.clx-qp__main',d).src=t.src;
          qsa('.clx-qp__thumb',d).forEach(function(x){x.classList.toggle('is-on',x===t);});
          return;
        }
        var mc=t.closest?t.closest('.clx-size[data-mvid]'):null;
        if(mc){
          d.setAttribute('data-msel',mc.getAttribute('data-mvid'));
          paintModalItem(d);
          return;
        }
        var atc=t.closest?t.closest('.clx-qp__atc'):null;
        if(atc){
          var vid=modalVid(d); if(!vid)return;
          addItems([{id:parseInt(vid,10),quantity:1}],atc).then(function(ok){
            if(ok)setTimeout(closeModal,700);
          });
        }
      });
      c.appendChild(d);
      paintModalItem(d);
    });
    if(failed>0){
      var n=document.createElement('p'); n.className='clx-qp__note';
      n.textContent=loaded.length?'Some items in this bundle aren’t published to the store yet — their photos will appear here once they go live.':'This item isn’t published to the store yet — its preview will appear once it goes live (drafts can’t be previewed).';
      c.appendChild(n);
    }
    if(!c.hasChildNodes())c.innerHTML='<p style="padding:30px;text-align:center">Preview unavailable right now.</p>';
  });
}

/* delegated clicks: quicklook, size-select chips, ATC, bundle keys */
function initDelegates(){
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('.clx-modal'))return;
    var ql=e.target.closest?e.target.closest('.clx-quicklook'):null;
    if(ql){e.preventDefault();openQuick((ql.getAttribute('data-handles')||'').split(','));return;}
    var atc=e.target.closest?e.target.closest('.clx-card__atc'):null;
    if(atc){
      var acard=atc.closest('.clx-card'); if(!acard)return;
      var vid=cardVid(acard); if(!vid)return;
      addItems([{id:parseInt(vid,10),quantity:1}],atc);
      return;
    }
    var ch=e.target.closest?e.target.closest('.clx-size'):null;
    if(!ch||ch.disabled)return;
    if(ch.hasAttribute('data-vid')){
      e.preventDefault();
      var card=ch.closest('.clx-card'); if(!card)return;
      card.setAttribute('data-selvid',ch.getAttribute('data-vid'));
      paintCards();
    } else if(ch.hasAttribute('data-bkey')){
      e.preventDefault();
      var bcard=ch.closest('.clx-bcard'); if(!bcard)return;
      bcard.setAttribute('data-selkey',ch.getAttribute('data-bkey'));
      paintBundles();
    }
  });
}

/* bundles */
function bundleMap(card){try{return JSON.parse(card.getAttribute('data-map')||'{}');}catch(e){return{};}}
function bundleKey(card){
  var map=bundleMap(card); var keys=Object.keys(map);
  if(!keys.length)return null;
  var selkey=card.getAttribute('data-selkey');
  if(selkey&&map[selkey])return selkey;
  if(map.onesize)return 'onesize';
  var dim=card.getAttribute('data-dim'); var sel=state[dim];
  if(sel&&sel!=='skip'){var hit=keys.filter(function(k){return norm(k)===norm(sel)||norm(k).indexOf(norm(sel))===0;})[0]; if(hit)return hit;}
  if(keys.length===1)return keys[0];
  return null;
}
function paintBundles(){
  qsa('.clx-bcard').forEach(function(card){
    var map=bundleMap(card); var keys=Object.keys(map);
    var chipWrap=qs('.clx-bcard__sizes',card);
    if(chipWrap&&!chipWrap.hasChildNodes()&&keys.length>1){
      keys.forEach(function(k){
        var b=document.createElement('button');b.type='button';b.className='clx-size';b.setAttribute('data-bkey',k);b.textContent=k.replace(' | Age',' ·');chipWrap.appendChild(b);
      });
    }
    var key=bundleKey(card);
    qsa('[data-bkey]',card).forEach(function(x){x.classList.toggle('is-match',x.getAttribute('data-bkey')===key);});
    var cta=qs('.clx-bcard__cta',card);
    if(cta&&!cta.classList.contains('is-busy')){
      if(!cta.getAttribute('data-label'))cta.setAttribute('data-label',cta.textContent);
      cta.disabled=!key;
      cta.textContent=key?cta.getAttribute('data-label'):'Pick a size';
    }
  });
}
function initBundles(){
  qsa('.clx-bcard__cta').forEach(function(cta){
    cta.addEventListener('click',function(){
      var card=cta.closest('.clx-bcard'); var key=bundleKey(card); if(!key)return;
      var ids=bundleMap(card)[key]||[];
      addItems(ids.map(function(id){return {id:id,quantity:1};}),cta);
    });
  });
  paintBundles();
}

/* sticky progress bar */
var pidSet=null;
function ids(){
  if(pidSet)return pidSet; pidSet={};
  qsa('.clx-card[data-pid]').forEach(function(c){pidSet[c.getAttribute('data-pid')]=1;});
  return pidSet;
}
function refreshBar(){
  var bar=qs('#clx-bar'); if(!bar)return;
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var set=ids(); var n=0;
    (cart.items||[]).forEach(function(it){ if(set[String(it.product_id)]) n+=it.quantity; });
    var t1=parseInt(bar.getAttribute('data-t1')||'3',10), t2=parseInt(bar.getAttribute('data-t2')||'6',10);
    var p1=bar.getAttribute('data-p1')||'20', p2=bar.getAttribute('data-p2')||'30';
    var txt, fill;
    if(bar.getAttribute('data-enabled')!=='true'){txt=n+' sale item'+(n===1?'':'s')+' in your cart';fill=Math.min(n/t2,1);}
    else if(n===0){txt='Mix & match any '+t1+'+ sale items — extra '+p1+'% off';fill=0;}
    else if(n<t1){txt='Add '+(t1-n)+' more sale item'+((t1-n)===1?'':'s')+' — unlock an extra '+p1+'% off';fill=n/t2;}
    else if(n<t2){txt='Extra '+p1+'% unlocked! '+(t2-n)+' more for '+p2+'% off';fill=n/t2;}
    else{txt='Max savings unlocked — extra '+p2+'% off your sale items';fill=1;}
    var te=qs('#clx-bar-text'); if(te)te.textContent=txt;
    var fe=qs('#clx-bar-fill'); if(fe)fe.style.width=Math.round(fill*100)+'%';
    bar.classList.add('is-visible');
  }).catch(function(){});
}
function initBar(){
  var b=qs('#clx-bar-cart'); if(b)b.addEventListener('click',function(){
    var t=qs('.js-drawer-open-cart'); if(t){t.click();}else{window.location.href='/cart';}
  });
  if(window.fetch){var of=window.fetch;window.fetch=function(input,init){
    var p=of.apply(this,arguments);
    try{var u=(typeof input==='string')?input:((input&&input.url)||'');
      if(/\/cart\/(add|change|update|clear)/.test(u)){p.then(function(){setTimeout(refreshBar,400);}).catch(function(){});}
    }catch(e){}
    return p;};}
  refreshBar();
}

function init(){initSaleSkus();initGate();initSizePanel();initCatChips();initDelegates();initBundles();initBar();applyFilter();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
